window.Varellea.register('announcement-bar', root => {
  const controller = new AbortController();
  const signal = controller.signal;
  const slides = [...root.querySelectorAll('[data-announcement-slide]')];
  const clocks = [...root.querySelectorAll('[data-countdown]')];
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let current = Math.max(0, slides.findIndex(slide => !slide.hidden));
  let timer;
  let clockTimer;
  let paused = false;

  function show(index) {
    if (!slides.length) return;
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, position) => { slide.hidden = position !== current; });
  }
  function updateClocks() {
    for (const clock of clocks) {
      const end = Date.parse(clock.dataset.countdown);
      if (Number.isNaN(end)) { clock.hidden = true; continue; }
      const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      clock.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      clock.dateTime = clock.dataset.countdown;
    }
  }
  function startRotation() {
    if (timer || slides.length < 2 || root.dataset.rotate !== 'true' || motion.matches) return;
    const interval = Number(root.dataset.interval) || 6000;
    timer = setInterval(() => { if (!paused && !document.hidden) show(current + 1); }, interval);
  }
  return {
    connect() {
      show(current);
      root.querySelector('[data-announcement-prev]')?.addEventListener('click', () => show(current - 1), { signal });
      root.querySelector('[data-announcement-next]')?.addEventListener('click', () => show(current + 1), { signal });
      root.addEventListener('mouseenter', () => { paused = true; }, { signal });
      root.addEventListener('mouseleave', () => { paused = false; }, { signal });
      root.addEventListener('focusin', () => { paused = true; }, { signal });
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) paused = false; }, { signal });
      root.addEventListener('varellea:block:select', event => {
        const slide = event.target.closest('[data-announcement-slide]');
        if (slide) { paused = true; show(slides.indexOf(slide)); }
      }, { signal });
      root.addEventListener('varellea:block:deselect', () => { paused = false; }, { signal });
      motion.addEventListener('change', () => { clearInterval(timer); timer = null; startRotation(); }, { signal });
      updateClocks();
      if (clocks.length) clockTimer = setInterval(updateClocks, 1000);
      startRotation();
    },
    disconnect() { controller.abort(); clearInterval(timer); clearInterval(clockTimer); }
  };
});
